import FetchData from '@ezviz/FetchData';

import { message } from "antd";
import Cookies from "js-cookie";
import intl from 'react-intl-universal';

// 获取一级类目列表
export const FETCH_MAINCATEGORY_LIST = "FETCH_MAINCATEGORY_LIST";
// 获取二级类目列表
export const FETCH_SUBCATEGORY_LIST = "FETCH_SUBCATEGORY_LIST";
// 更新功能点编辑
export const UPDATE_FEATUREEDIT_DATA = "UPDATE_FEATUREEDIT_DATA";
// 设置弹窗状态
export const SET_FEATUREEDITMODALVISIBLE = "SET_FEATUREEDITMODALVISIBLE";
// 设置操作类型
export const SET_OPERATETYPE = "SET_OPERATETYPE";
// 设置loading状态
export const SET_CONFIRMLOADING = "SET_CONFIRMLOADING";
export const GET_DOMAIN = "GET_DOMAIN"

export function fetchMainCategoryList() {
  return (dispatch, getState) => {
    const url = `/iot/config/api/iot/support/category/main`;
    const fetchData = new FetchData(url, {
      method: 'GET',
      headers: {
        accessToken: Cookies.get('accessToken')
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_MAINCATEGORY_LIST,
            mainCategoryList: res.data || []
          })
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      })
  }
}

export function fetchSubCategoryList(param = {}) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_SUBCATEGORY_LIST,
      subCategoryList: []
    });
    const { mainCategoryId } = param;
    const url = `/iot/config/api/iot/support/category/sub?mainCategoryId=${mainCategoryId}`;
    const fetchData = new FetchData(url, {
      method: 'GET',
      headers: {
        accessToken: Cookies.get('accessToken')
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_SUBCATEGORY_LIST,
            subCategoryList: res.data || []
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      })
  }
}

export function fetchResourceTplList(params = {}, callback) {
  return (dispatch, getState) => {
    const { subCatKey } = params;
    const url = `/iot/config/api/iot/support/std/resourceTpl?subCatKey=${subCatKey}`;
    const fetchData = new FetchData(url, {
      method: "GET",
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback && callback(res);
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      })
  }
}

export function fetchFeatureList(params = {}, callback) {
  return (dispatch, getState) => {
    const {
      resourceId,
      pageStart = 0,
      pageSize = 10,
    } = params;
    const url = `/iot/config/api/iot/support/std/feature?resourceId=${resourceId}&pageStart=${pageStart}&pageSize=${pageSize}`;
    const fetchData = new FetchData(url, {
      method: "GET",
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback && callback(res);
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      })
  }
}

export function addResourceModule(param = {}, callback) {
  return (dispatch, getState) => {
    const url = "/iot/config/api/iot/support/std/resourceTpl/add";
    const fetchData = new FetchData(url, {
      method: "POST",
      body: param,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback && callback(res);
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      })
  }
}

export function editResourceModule(param = {}, callback) {
  return (dispatch, getState) => {
    const url = "/iot/config/api/iot/support/std/resourceTpl";
    const fetchData = new FetchData(url, {
      method: "POST",
      body: param,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback && callback(res);
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      })
  }
}

export function delResourceModule(param = {}, callback) {
  return (dispatch, getState) => {
    const url = "/iot/config/api/iot/support/std/resourceTpl/del";
    const fetchData = new FetchData(url, {
      method: "DELETE",
      body: param,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback && callback(res);
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      })
  }
}

export function fetchFeaturesByName(param = {}, callback) {
  return (dispatch, getState) => {
    const url = `/iot/config/api/iot/support/std/featureByName`;
    const fetchData = new FetchData(url, {
      method: "GET",
      body: param,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback && callback(res);
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      })
  }
}

export function modifyFeature(param = {}, callback) {
  return (dispatch, getState) => {
    const url = `/iot/config/api/iot/support/std/product/feature`;
    const fetchData = new FetchData(url, {
      method: "POST",
      body: param,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback && callback(res);
      })
      .catch(e => {
        console.log(e);
        message.error(intl.get('commmon.operate.netRetry'));
      })
  }
}

export function delFeature(param = {}, callback) {
  return (dispatch, getState) => {
    const url = `/iot/config/api/iot/support/std/feature`;
    const fetchData = new FetchData(url, {
      method: "DELETE",
      body: param,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback && callback(res);
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      })
  }
}

// 新增自定义功能点
export function addNewFeatureEdit() {
  return (dispatch, getState) => {
    const data = {
      id: 1,
      // 功能点类型 "prop"-属性，"action"-操作，"event"-事件
      ftype: "prop",
      // 功能名称	
      name: '',
      // 功能名称(中文)	
      deNameCh: '',
      // 功能名称(英文)	
      deNameEn: '',
      //ptype为STD代表标准功能,CUSTOM为自定义功能
      ptype: "STD",
      // 领域识别符
      domainKey: "",
      // 识别符
      key: '',
      // 是否可选	0 必选 1 可选
      //"r"-只上报；w-只下发；rw"-上报下发
      access: "r",
      optional: 1,
      // 功能备注	
      remark: '',
      //schema
      schema: {
        type: "boolean",
      },
      emphasis: 0,
      //响应
      output: { type: "noinput" },
      //请求
      input: { type: "noinput" },
      //事件类型
      eventType: "notification"
    }
    dispatch(updateFeatureEditData(data));
    dispatch(setOperateType('add'));
    dispatch(setFeatureEditModalVisible(true));
  }
}

// 更新功能点编辑
export function updateFeatureEditData(data) {
  return (dispatch, getState) => {
    const { featureEditData } = getState().categoryModel;
    const newData = Object.assign({}, featureEditData, data);
    const newDeName = { zh: newData.deNameCh, en: newData.deNameEn }
    const lastData = { ...newData, name: JSON.stringify(newDeName) }
    dispatch({
      type: UPDATE_FEATUREEDIT_DATA,
      featureEditData: lastData,
    });
  };
}

// 设置弹窗状态
export function setFeatureEditModalVisible(value) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_FEATUREEDITMODALVISIBLE,
      featureEditModalVisible: value,
    });
  };
}

// 设置操作类型
export function setOperateType(value) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_OPERATETYPE,
      operateType: value,
    });
  };
}

// 保存功能点配置
export function saveFeatureEditData(params, callback) {
  console.log('saveFeatureEditData----', params)
  return (dispatch, getState) => {
    const { operateType, featureEditData } = getState().categoryModel;
    const url = `/iot/config/api/iot/support/std/product/feature`;
    let body = {};
    //默认遥测数据
    let propertiesOfNotification = {
      type: "object",
      title: "",
      properties: {
        basic: {
          type: "object",
          title: "基础内容",
          properties: {
            dateTime: {
              type: "string",
              title: "事件时间",
              description: "格式为 YYYY-MM-DD'T'HH:mm:ss+zone，例2017-08-01T17:30:08+08:00,或则格式 YYYY-MM-DD'T'HH:mm:ss.fff+zone，（毫秒精度）例2017-08-01T17:30:08.134+08:00设备支持毫秒，优先传毫秒。",
              maxLength: 32,
              minLength: 25
            },
            UUID: {
              type: "string",
              title: "上传事件唯一标识符",
              minLength: 1,
              maxLength: 32
            },
            continue: {
              type: "boolean",
              title: "后续有相同UUID的报文(用于补充图片)",
              default: false,
              const: false,
              description: "默认为false，后续不会有相同UUID的报文。不带图片或则带图片的事件无实时性要求，该节点可以不要。"
            },
            timestamp: {
              type: "number",
              description: "消息时间戳，UTC 1970-01-01 0时开始的毫秒数。行业设备可以不带"
            },
            ipV4Address: {
              type: "string",
              format: "ipv4"
            },
          },
          required: [
            "dateTime",
            "UUID"
          ]
        },
        notification: {
          type: "object",
          description: "提醒消息基础字段，所有告警提醒类消息必须携带",
          properties: {
            status: {
              type: "number",
              title: "事件状态",
              description: "1发生，2停止，该字段目前无实际效果，但予以保留",
              enum: [
                1,
                2
              ]
            },
            action: {
              type: "number",
              title: "自定义特殊提醒行为",
              description: "默认为0。目前开放的选项是——：8：不推送"
            },
            location: {
              type: "string",
              title: "设备安装位置",
              description: ""
            },
            relationId: {
              type: "string",
              title: "互联互通消息ID",
              description: "是一个UUID，平台会将多个具有相同relationId的消息关联起来在App上查看。",
              maxLength: 64,
              minLength: 0
            },
            pictures: {
              type: "array",
              title: "",
              items: {
                type: "object",
                title: "图片信息",
                properties: {
                  cloudtype: {
                    type: "integer",
                    description: "云存储类型，根据图片上传信息响应中的同名字段填写 ",
                    title: "存储节点编号，当采用简单存储协议时，为固定值 -1"
                  },
                  bucket: {
                    type: "string",
                    description: "云存储bucket名称，根据图片上传信息响应中的同名字段填写",
                    title: "存储桶信息，采用简单存储协议时，为空"
                  },
                  type: {
                    type: "string",
                    description: "图片格式",
                    title: "文件格式"
                  },
                  length: {
                    type: "integer",
                    description: "图片长度",
                    title: "图片长度",
                    unit: "字节"
                  },
                  crypt: {
                    type: "integer",
                    description: "加密类型：2平台加密，1设备加密，0不加密。注意一条消息中的所有图片必须采用相同的加密方式与加密密钥。",
                    title: "加密类型",
                    enum: [
                      0,
                      1,
                      2
                    ],
                    enumDesc: [
                      "不加密",
                      "设备密钥加密（别称“设备加密”）：密钥是设备本地的验证码，平台不存储，由事件接收方自行根据设备密钥解密",
                      "共享密钥加密（别称“平台加密”）：可以做到每个事件一个密钥， 密钥随业务流程自行传递（多为陪伴事件一起传输），平台服务根据获得的密钥可以转换为解密后的地址。"
                    ]
                  },
                  fileid: {
                    type: "string",
                    description: "存储KEY,根据图片上传信息响应中的同名字段填写",
                    title: "存储KEY"
                  },
                  tinyvideo: {
                    type: "integer",
                    description: "0-没有报警小视频；1-有报警小视频  ",
                    title: "报警小视频",
                    enum: [
                      0,
                      1
                    ],
                    enumDesc: [
                      "没有报警小视频",
                      "有报警小视频"
                    ]
                  },
                  checksum: {
                    type: "string",
                    description: " 对应老协议CapturePicture:CheckSum，如为设备加密，则是设备密钥的checksum，如为平台加密，则为平台加密的密钥部分信息。如没有加密则为空",
                    title: "校验和",
                    minLength: 0,
                    maxLength: 32
                  },
                  lifecycle: {
                    type: "integer",
                    description: " 云图片的存储周期 ，根据图片上传信息响应中的同名字段填写。该字段仅作记录，不会实际影响图片的存储周期。  ",
                    title: "云图片的存储周期",
                    unit: "天"
                  }
                },
                required: [
                  "cloudtype",
                  "bucket",
                  "fileid"
                ]
              }
            }
          },
        },
        payload: {
          type: "object",
          title: "自定义内容",
          properties: {
            value: {
              ...featureEditData.schema
            }
          },
          required: [
            "value"
          ]
        }
      }
    }
    //默认提醒数据
    let propertiesOfTelemeter = {
      "type": "object",
      "title": "",
      "properties": {
        "basic": {
          "type": "object",
          "description": "事件基础信息，所有事件都必须携带，不可修改",
          "properties": {
            "dateTime": {
              "type": "string",
              "title": "事件时间",
              "description": "格式为 YYYY-MM-DD'T'HH:mm:ss+zone，例2017-08-01T17:30:08+08:00,或则格式 YYYY-MM-DD'T'HH:mm:ss.fff+zone，（毫秒精度）例2017-08-01T17:30:08.134+08:00设备支持毫秒，优先传毫秒。",
              "maxLength": 32,
              "minLength": 25
            },
            "UUID": {
              "type": "string",
              "title": "事件的UUID",
              "description": "一般为32位字符串，不可重复（重复ID会被认为是同一事件而过滤）",
              "maxLength": 64,
              "minLength": 0
            }
          },
          "required": [
            "dateTime",
            "UUID"
          ]
        },
        "telemeter": {
          "type": "object",
          "description": "遥测事件，不可再选择basic以外的事件模板，可以在value之外，再定义1~4个遥测指标，指标必须为number或integer类型",
          "properties": {
            "value": {
              "type": "number",
              "title": "遥测数值",
              "description": "默认的遥测数值"
            }
          },
          "required": ["value"]
        }
      }
    }
    // 接口的物模型功能点数据进行遍历，将枚举类型去掉
    function findAndModifyEnum(data) {
      // 检查当前数据是否是对象
      if (typeof data !== 'object' || data === null) {
        return data;
      }

      // 如果是数组，遍历每个元素
      if (Array.isArray(data)) {
        data.forEach((item, index) => {
          data[index] = findAndModifyEnum(item);
        });
        return data;
      }

      // 如果是对象，遍历每个属性
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          // 先找需要复制的参数
          const value = data[key];
          // 如果属性是 'type' 并且值为 'enum'，则修改其值
          if (key === 'type' && value === 'enum') {
            data[key] = data.enumType;
            if (data.enumType === 'string') {
              data.maxLength = 250;
            }
            if (data.enumType === 'integer' || data.enumType === 'number') {
              data.minimum = 0;
              data.maximum = 100000000
            }
            data['enum'] = data.enumValue;
            delete data.enumValue;
          } else {
            // 递归处理子对象或数组
            data[key] = findAndModifyEnum(value);
          }
        }
      }
      return data;
    }
    if (featureEditData.ftype == "prop") {
      if ((featureEditData.schema.type == "array" && featureEditData.schema.minItems == null) || (featureEditData.schema.type == "array" && featureEditData.schema.maxItems == null)) {
        message.error(intl.get('category.studio.arrMaxTips') + intl.get('commmon.tip.notBlank'))
        return
      }
      if (featureEditData.schema.properties && Object.keys(featureEditData.schema.properties).some(item => item.length == 0)) {
        message.error(intl.get('home.product.feature.paramKey.notEmpty'))
        return
      }
      if (featureEditData.schema.properties && Object.keys(featureEditData.schema.properties).length > 0) {
        let isOk = false;
        Object.keys(featureEditData.schema.properties).map(item => {
          if (item.length > 0) {
            const eachSchemaDetail = Object.assign(featureEditData.schema.properties[item])
            if (eachSchemaDetail.enum && eachSchemaDetail.enum.length > 0 && eachSchemaDetail.enum.some(v => v == "")) {
              isOk = true;
            }
          }
        })
        if (isOk) {
          message.error(intl.get('home.product.feature.enum.value') + intl.get('commmon.tip.notBlank'))
          return
        }
      }

      let featureForm = featureEditData.schema;
      const modifiedData = findAndModifyEnum(featureForm);
      body = {
        propVo: {
          access: featureEditData.access,
          did: featureEditData.did,
          id: featureEditData.id,
          key: featureEditData.key,
          name: featureEditData.name,
          noPush: true,
          // optional: 0,
          ptype: featureEditData.ptype,
          publishVersion: 0,
          remark: featureEditData.remark,
          schema: JSON.stringify(transSchema(modifiedData)),
          sort: 0,
          tplPublishId: 0,
          tplPublishVersion: 0,
        },
        resKey: params.resKey,
        resId: params.resId,
        catKey: params.catKey,
        domainKey: 'global',
        // domainKey: featureEditData.domainKey,
      }
    }
    if (featureEditData.ftype == "action") {
      if ((featureEditData.input.type == "array" && featureEditData.input.minItems == null) || (featureEditData.input.type == "array" && featureEditData.input.maxItems == null)) {
        message.error(intl.get('category.studio.arrMaxTips') + intl.get('commmon.tip.notBlank'))
        return
      }
      if ((featureEditData.output.type == "array" && featureEditData.output.minItems == null) || (featureEditData.output.type == "array" && featureEditData.output.maxItems == null)) {
        message.error(intl.get('category.studio.arrMaxTips') + intl.get('commmon.tip.notBlank'))
        return
      }
      if (featureEditData.input.properties && Object.keys(featureEditData.input.properties).some(item => item.length == 0)) {
        message.error(intl.get('category.studio.parameterIdentifier') + intl.get('commmon.tip.notBlank'))
        return
      }
      if (featureEditData.input.properties && Object.keys(featureEditData.input.properties).length > 0) {
        let isOk = false;
        Object.keys(featureEditData.input.properties).map(item => {
          if (item.length > 0) {
            const eachSchemaDetail = Object.assign(featureEditData.input.properties[item])
            if (eachSchemaDetail.enum && eachSchemaDetail.enum.length > 0 && eachSchemaDetail.enum.some(v => v == "")) {
              isOk = true;
            }
          }
        })
        if (isOk) {
          message.error(intl.get('home.product.feature.enum.value') + intl.get('commmon.tip.notBlank'))
          return
        }
      }
      if (featureEditData.output.properties && Object.keys(featureEditData.output.properties).some(item => item.length == 0)) {
        message.error(intl.get('category.studio.parameterIdentifier') + intl.get('commmon.tip.notBlank'))
        return
      }

      if (featureEditData.output.properties && Object.keys(featureEditData.output.properties).length > 0) {
        let isOk = false;
        Object.keys(featureEditData.output.properties).map(item => {
          if (item.length > 0) {
            const eachSchemaDetail = Object.assign(featureEditData.output.properties[item])
            if (eachSchemaDetail.enum && eachSchemaDetail.enum.length > 0 && eachSchemaDetail.enum.some(v => v == "")) {
              isOk = true;
            }
          }
        })
        if (isOk) {
          message.error(intl.get('home.product.feature.enum.value') + intl.get('commmon.tip.notBlank'))
          return
        }
      }

      const modifiedDataInput = findAndModifyEnum(featureEditData.input);
      const modifiedDataOutput = findAndModifyEnum(featureEditData.output);

      body = {
        actionVo: {
          did: featureEditData.did,
          direction: "Plt2Dev",
          id: featureEditData.id,
          input: featureEditData.input && featureEditData.input.type == 'noinput' ? "{}" : JSON.stringify(transSchema(modifiedDataInput)),
          key: featureEditData.key,
          name: featureEditData.name,
          // optional: 0,
          output: featureEditData.output && featureEditData.output.type == 'noinput' ? "{}" : JSON.stringify(transSchema(modifiedDataOutput)),
          publishVersion: 0,
          remark: featureEditData.remark,
          sort: 0,
          statusCode: "string",
          tplPublishId: 0,
          tplPublishVersion: 0,
        },
        resId: params.resId,
        resKey: params.resKey,
        catKey: params.catKey,
        domainKey: 'global',
        // domainKey: featureEditData.domainKey,
      }
    }
    if (featureEditData.ftype == "event") {
      const propertiesOfTelemeterAA = findAndModifyEnum(propertiesOfTelemeter);
      const propertiesOfNotificationAA = findAndModifyEnum(propertiesOfNotification);

      body = {
        eventVo: {
          did: featureEditData.did,
          etype: featureEditData.etype,
          eventType: JSON.stringify([featureEditData.eventType]),
          id: featureEditData.id,
          key: featureEditData.key,
          msg: {},
          name: featureEditData.name,
          // optional: 0,
          productConfig: {},
          publishVersion: 0,
          remark: featureEditData.remark,
          schema: featureEditData.eventType == "telemeter" ? JSON.stringify(changeSchema(propertiesOfTelemeterAA)) : JSON.stringify(changeSchema(propertiesOfNotificationAA)),
          sort: 0,
          tplPublishId: 0,
          tplPublishVersion: 0,
        },
        resId: params.resId,
        resKey: params.resKey,
        catKey: params.catKey,
        domainKey: 'global',
        // domainKey: featureEditData.domainKey,
      }
    }

    // body.eventType = ["notification", "general"]

    dispatch(setConfirmLoading(true));
    const fetchData = new FetchData(url, {
      method: operateType === 'add' ? "POST" : "PUT",
      body: body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        dispatch(setConfirmLoading(false));
        if (res.code == 200 || (res.meta && res.meta.code == 200)) {
          callback && callback();
          dispatch(setFeatureEditModalVisible(false))
          message.success(intl.get('commmon.operate.success'));
        } else {
          message.error(res.msg || (res.meta && res.meta.message) || intl.get('commmon.operate.netRetry'));
        }
      })
      .catch(e => {
        dispatch(setConfirmLoading(false));
        message.error(intl.get('commmon.operate.netRetry'));
      });
  };
}

// 设置操作类型
export function setConfirmLoading(value) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_CONFIRMLOADING,
      confirmLoading: value,
    });
  };
}

//schema数据处理
const transSchema = (schema) => {
  // Object.keys(schema).map(item => {
  //   if(!schema[item]) {
  //     delete schema[item]
  //   }else 
  //   if( item == "properties" || item == "items"){
  //     schema[item] = transSchema(schema[item])
  //   }
  // })
  let newProperties = {};
  if (schema.properties) {
    Object.keys(schema.properties).map(item => {
      if (item.length > 0) {
        newProperties[item] = schema.properties[item]
      }
    })
    schema.properties = newProperties
  }
  let value = changeSchema(schema);
  return value;
}

const changeSchema = (schema) => {
  Object.keys(schema).forEach(item => {
    if (schema[item] === null) {
      delete schema[item];
    }
    if (schema[item] !== null && typeof schema[item] == 'object') {
      changeSchema(schema[item]);
    }
  })
  return schema;
}

// 编辑功能点
export function editFeature(data) {
  return (dispatch, getState) => {
    dispatch(startFeatureEdit(data))
  };
}

// 编辑已添加的功能点
export function startFeatureEdit(value) {
  return (dispatch, getState) => {
    const data = value;
    // //判断是否是事件，如果是取事件的deInput
    // const isEvent = value.deInput
    //   && value.deInput.properties
    //   && value.deInput.properties.payload
    //   && value.deInput.properties.payload.properties
    //   && value.deInput.properties.payload.properties.value
    // data.deInput = isEvent ? value.deInput.properties.payload.properties.value : value.deInput;
    // // 名称增加中英文
    // data.name = { zh: value.deNameCh, en: value.deNameEn };

    dispatch(updateFeatureEditData(data));
    dispatch(setOperateType('edit'));
    dispatch(setFeatureEditModalVisible(true));
  }
}

// 查询当前模块领域识别符
export function fetchDomain(param, successCallback = () => { }, failCallback = () => { }) {
  return (dispatch, getState) => {
    // const appId = window.applicationId;
    const body = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/std/domain`, {
      method: 'GET',
      headers: {
        // appId,
      },
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res && res.code == 200) {
          dispatch({
            type: GET_DOMAIN,
            stdDomainList: res.data || []
          });
          return successCallback(res.data)

        } else {
          failCallback();
          message.error(res.msg || intl.get('commmon.operate.netRetry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}
